import type { UserType } from '@/types/AuthState';

/** UserStatus values as surfaced by the read model (admin parity). */
export type ExternalUserStatus = 'Active' | 'Inactive' | 'Unregistered';

/**
 * Transport shape for GET /private/v1/users/external — field-for-field mirror
 * of the gateway's ExternalUserById view (cqrs-repo, user-contracts). The
 * endpoint returns a bare ExternalUserDTO[]; there is no envelope and no seat
 * summary.
 */
export interface ExternalUserDTO {
  id: string;
  organizationId: string;
  name: string;
  email: string;
  phone: string;
  userType: UserType;
  departmentOrganization: string;
  status: ExternalUserStatus;
  isEmailVerified: boolean;
  isPhoneVerified: boolean;
  createdAt: string;
  updatedAt: string;
  credentialsResetRequired: boolean;
  sixCount: number;
  /** Email of the creating user, or a label (e.g. "Admin") for admin-created accounts. */
  createdByAccount: string;
}

/** Frontend domain model rendered by the External Users screen. */
export interface ExternalUser {
  id: string;
  name: string;
  email: string;
  phone: string;
  deptOrg: string;
  status: ExternalUserStatus;
  sixCount: number;
  createdByAccount: string;
}

export type ExternalUserSortKey =
  | 'name'
  | 'email'
  | 'phone'
  | 'deptOrg'
  | 'status'
  | 'createdByAccount'
  | 'sixCount';

export type ExternalUserSortDir = 'asc' | 'desc';

export type ExternalUserStatusFilter = 'All' | ExternalUserStatus;

export interface ExternalUsersState {
  users: ExternalUser[];
  isLoaded: boolean;
  isDeleting: boolean;
  /** Sidebar-toggled filter: only external users created by the current user. */
  invitedByMeOnly: boolean;
  error: string | null;
}

export const initialExternalUsersState: ExternalUsersState = {
  users: [],
  isLoaded: false,
  isDeleting: false,
  invitedByMeOnly: false,
  error: null,
};
